import { useState } from "react";
import { api, fmtError } from "@/lib/api";
import { X, Flag, Loader2 } from "lucide-react";
import { toast } from "sonner";

const REASONS = ["Fake / false emergency", "Harassment", "Threats", "Hate speech", "Impersonation", "Spam", "Other"];

export const ReportModal = ({ open, onClose, targetUserId, targetEmergencyId, targetPostId, targetLabel }) => {
  const [reason, setReason] = useState(REASONS[0]);
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/reports", { reason, details, target_user_id: targetUserId || null, target_emergency_id: targetEmergencyId || null, target_post_id: targetPostId || null });
      toast.success("Report submitted for community admin review.");
      setDetails("");
      onClose();
    } catch (e) { toast.error(fmtError(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-[#111827]/60 z-[80] flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="bg-white w-full max-w-md rounded-t-3xl sm:rounded-3xl p-6 ll-fade-up" onClick={(e) => e.stopPropagation()} data-testid="report-modal">
        <div className="flex justify-between items-center mb-1">
          <h2 className="text-2xl font-bold font-head flex items-center gap-2"><Flag className="w-5 h-5 text-[#DC2626]" /> Report a concern</h2>
          <button onClick={onClose} data-testid="report-close" className="w-9 h-9 rounded-full bg-[#111827]/5 flex items-center justify-center"><X className="w-5 h-5" /></button>
        </div>
        {targetLabel && <p className="text-sm text-[#111827]/50 mb-4">About: <span className="font-semibold">{targetLabel}</span></p>}
        <label className="block mb-3">
          <span className="text-sm font-bold uppercase tracking-wider text-[#111827]/70">Reason</span>
          <select data-testid="report-reason" value={reason} onChange={(e) => setReason(e.target.value)} className="mt-1.5 bg-[#FFF7E6] border-2 border-[#111827]/10 rounded-xl p-4 text-lg w-full outline-none focus:border-[#F97316]">
            {REASONS.map((r) => <option key={r}>{r}</option>)}
          </select>
        </label>
        <textarea data-testid="report-details" value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Add details (optional)" rows={3} className="bg-[#FFF7E6] border-2 border-[#111827]/10 rounded-xl p-4 w-full outline-none focus:border-[#F97316] mb-2" />
        <p className="text-xs text-[#111827]/40 mb-4">Reports are sent to your community admin for review. Misuse of reporting is also prohibited.</p>
        <button data-testid="report-submit" onClick={submit} disabled={busy} className="w-full bg-[#DC2626] text-white rounded-2xl py-4 font-bold min-h-[56px] flex items-center justify-center">{busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Submit report"}</button>
      </div>
    </div>
  );
};
